'use client';

import { useEffect, useState, useCallback, useRef } from 'react';
import DdayCountdown from '@/src/components/common/footer/DdayCountdown';
import AnimationComponent from '../../global/interactive/AnimationComponent';
import { cx } from '@/src/styles/stylebook';
const frames = {
  idle: [0, 29],
  close: [60, 89]
};
const Countdown = ({
  animationData,
  yearData
}) => {
  const [isIdle, setIsIdle] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const lastActivityRef = useRef(Date.now()); // 1분 전으로 설정해서 즉시 테스트 가능
  const [currentFrames, setCurrentFrames] = useState(null);
  const [shouldRender, setShouldRender] = useState(true);
  const [shouldPlay, setShouldPlay] = useState(false);
  if (!yearData) return null;

  // 마우스/터치 활동 감지
  const handleActivity = useCallback(() => {
    lastActivityRef.current = Date.now();
    if (isIdle && !isClosing) {
      setIsClosing(true);
      setCurrentFrames(frames.close);
      setShouldPlay(true);
    }
  }, [isIdle, isClosing]);

  // 인터랙션 감지 이벤트 리스너 등록 - 최적화
  useEffect(() => {
    // 중복 제거, passive 옵션 추가
    const events = [{
      name: 'mousemove',
      options: {
        passive: true
      }
    }, {
      name: 'mousedown',
      options: {}
    }, {
      name: 'keydown',
      options: {}
    }, {
      name: 'touchstart',
      options: {
        passive: true
      }
    }, {
      name: 'scroll',
      options: {
        passive: true
      }
    }, {
      name: 'visibilitychange',
      options: {}
    }];
    events.forEach(({
      name,
      options
    }) => {
      document.addEventListener(name, handleActivity, options);
    });
    return () => {
      events.forEach(({
        name: name_0
      }) => {
        document.removeEventListener(name_0, handleActivity);
      });
    };
  }, [handleActivity]);

  // 3초 비활성 체크
  useEffect(() => {
    if (isIdle || isClosing) return;
    let timeoutId;
    const scheduleCheck = () => {
      const now = Date.now();
      const timeSinceActivity = now - lastActivityRef.current;
      if (timeSinceActivity >= 60000) {
        // 1분 = 60000ms
        setCurrentFrames(frames.idle);
        setIsIdle(true);
        setShouldRender(true);
        setShouldPlay(true);
      } else {
        const remainingTime = 60000 - timeSinceActivity;
        timeoutId = setTimeout(scheduleCheck, remainingTime);
      }
    };
    scheduleCheck();
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isIdle, isClosing]);

  // 애니메이션 완료 처리
  const handleAnimationComplete = useCallback(() => {
    if (isClosing) {
      // 닫기 애니메이션 완료 → 0프레임으로 복귀하고 숨김
      setIsClosing(false);
      setIsIdle(false);
      setShouldRender(false);
      setShouldPlay(false);
    } else if (isIdle) {
      // 유휴 애니메이션 완료 → 29프레임에서 정지
      setShouldPlay(false);
    }
  }, [isClosing, isIdle]);
  return <div className={cx('fixed top-0 left-0 z-300 h-full w-full transition-all duration-300 ease-in-out select-none', isIdle ? 'bg-gray-0/50 block opacity-100' : 'hidden bg-transparent opacity-0')} data-layer="Countdown">
      <AnimationComponent animationData={animationData} startFrame={currentFrames?.[0]} endFrame={currentFrames?.[1]} loop={false} autoplay={false} play={shouldPlay} onComplete={currentFrames ? handleAnimationComplete : undefined} className="absolute top-0 left-0 h-full w-full" preserveAspectRatio="none" />

      <DdayCountdown duration={yearData} className={cx('transition-all duration-300 ease-in-out', isClosing || shouldPlay || !shouldRender ? 'opacity-0' : 'opacity-100')} />
    </div>;
};
export default Countdown;